export enum DatePickerNames {
    To = 'to',
    From = 'from',
}
